import { useEffect, useState } from "react";
import type { markdownOutline } from "./codeMirror/extensions/markdownOutline.js";

/**
 * The `MarkdownOutline` extension, or undefined until it loads. It imports
 * CodeMirror, so it loads lazily, like the editor (see `LazyProseEditor`).
 */
export function useMarkdownOutline(): typeof markdownOutline | undefined {
  const [outline, setOutline] = useState<typeof markdownOutline>();

  useEffect(() => {
    void import("./codeMirror/extensions/markdownOutline.js").then(
      (module) => {
        setOutline(() => module.markdownOutline);
      },
      (error: unknown) => {
        console.error("Failed to load the markdown outline:", error);
      },
    );
  }, []);

  return outline;
}
